<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="0 0 24 24" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g 
            stroke="none" 
            stroke-width="1" 
            fill="none" 
            fill-rule="evenodd"
        >
            <g>
                <rect 
                    fill-rule="nonzero" 
                    x="0" 
                    y="0" 
                    width="24" 
                    height="24"
                ></rect>
                <line 
                    x1="4" 
                    y1="5" 
                    x2="16" 
                    y2="5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                ></line>
                <line 
                    x1="4" 
                    y1="12" 
                    x2="10" 
                    y2="12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                ></line>
                <line 
                    x1="14" 
                    y1="12" 
                    x2="20" 
                    y2="12"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                ></line>
                <line 
                    x1="8" 
                    y1="19" 
                    x2="20" 
                    y2="19" 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round"
                ></line>
                <circle 
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    cx="18" 
                    cy="5" 
                    r="2"
                ></circle>
                <circle
                    stroke="currentColor" 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    cx="12" 
                    cy="12" 
                    r="2"
                ></circle>
                <circle
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    cx="6"
                    cy="19"
                    r="2"
                ></circle>
            </g>
        </g>
    </svg>
</template>